module.exports = __webpack_public_path__ + "img/icon_map_188_on_010.96e99676.png";